import { render, staticRenderFns } from "./CustomerRelatedPerson.vue?vue&type=template&id=681de360&"
import script from "./CustomerRelatedPerson.vue?vue&type=script&lang=js&"
export * from "./CustomerRelatedPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports